import React, { useState, useEffect } from "react";
import { Host,Port} from '../Routes/apiConfig';
import { ResponsiveContainer } from "recharts"; // Import ResponsiveContainer
import {Table,DatePicker,Button,Modal,Form,message,Input,Space,Layout,Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import {SearchOutlined,EditOutlined,DeleteOutlined,QuestionCircleOutlined} from "@ant-design/icons";
import Cookies from "js-cookie";
import Axios from "axios";
import { useLayout } from "../LayoutContext";
import MyHeader from "../compo/Header";
import { useTranslation } from "react-i18next";
import './pages-css/subscribers.css'
import Dashboard from './Dashboard'
import { useUserRole } from '../UserRoleContext';
const storedUserRole = localStorage.getItem('userRole');
const DrawWinners = ({colorTheme}) => {
  const { userRole } = useUserRole();
  const { isLtr } = useLayout();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const sessionKey = Cookies.get("sessionKeySwin");
  useEffect(() => {
    const sessionKey = Cookies.get("sessionKeySwin");
    if (!sessionKey) {
      navigate("/login");
    }
  }, [navigate]);
  /*********************************************************/
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const headers={
    headers: {
      "hyazs-session-key": sessionKey,
      "HYAZS-API-KEY":
        "rYJ1riRCUqRHMwQH47UCOYwPnfigX1X-aeeTVYyxVTSWKsSup0VXS-K1",
    },
  }
  /*********************************************************/
  const fetchData = async () => {
    try {
      setLoading(true);
      const subscribersApi=`${Host}:${Port}/draw/private_codes`;

      const response = await Axios.get(subscribersApi,headers);
      if (response.data.statusCode < 0 && response.data.statusCode !== -101) {
        message.error(response.data.message);
      } else if (response.data.statusCode === -101) {
        Cookies.remove("sessionKeySwin");
        navigate("/login");
      } else {
        setData(response.data.data);
        console.log("the response Data:",response);
        // await fetchDataaa(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }finally {
      setLoading(false); // Set loading to false once the data is fetched
    }
  };
  /*********************************************************/
  const editRecord = (record) => {
    setEditingRecord(record);
    form.setFieldsValue(record);
    setVisible(true);
  };

  const deleteRecord = async (id) => {
    try {
      await Axios.delete("/api/records/delete", { data: { id } });
      fetchData();
    } catch (error) {
      console.error("Failed:", error);
    }
  };
  /*********************************************************/
  const handleOk = async (e) => {
    e.preventDefault();
  
    try {
      const values = await form.validateFields();
  
      if (editingRecord) {
        const updatedData = {
          id: editingRecord.id,
          mobile: values.mobile,
          password: values.password,
        };
  
        await Axios.put(
          `${Host}:${Port}/admin/subscribers`,
          updatedData,
          {
            headers: {
              "hyazs-session-key": sessionKey,
              "HYAZS-API-KEY":
                "rYJ1riRCUqRHMwQH47UCOYwPnfigX1X-aeeTVYyxVTSWKsSup0VXS-K1",
            },
          }
        )
          .then((response) => {
            if (response.data.statusCode === 0) {
              message.warning('Your custom warning message goes here');
            } else {
              message.success('Update successful'); // Show a success message for a successful update
            }
            fetchData();
          })
          .catch((error) => {
            // Handle an error
            console.error("Update Error:", error);
          });
      }
      fetchData();
      setVisible(false);
      form.resetFields();
    } catch (error) {
      console.error("Failed:", error);
    }
  };


  /*********************************************************/
  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  useEffect(() => {
    fetchData();
  }, []);
  
/*******************Subscriber-Info-button************************/
const navigateToWithData = (data) => {
  localStorage.setItem('userId', data.id);
  navigate(`/userInfo`);
};
/********************End_Subscriber-Info-button***********************/

  const columns = [
    {
      title: "User Id",
      dataIndex: "user_id",
      key: "user_id",
      // sorter: (a, b) => a.key - b.key,
      // onFilter: (value, record) => record.id.toString().includes(value), // Use 'id' here
      // filterDropdown: ({
      //   setSelectedKeys,
      //   selectedKeys,
      //   confirm,
      //   clearFilters,
      // }) => (
      //   <div style={{ padding: 8 }}>
      //     <Input
      //       placeholder="Search ID"
      //       value={selectedKeys[0]}
      //       onChange={(e) =>
      //         setSelectedKeys(e.target.value ? [e.target.value] : [])
      //       }
      //       onPressEnter={() => confirm()}
      //       style={{ width: 188, marginBottom: 8, display: "block" }}
      //     />
      //     <Button
      //       type="primary"
      //       onClick={() => confirm()}
      //       icon={<SearchOutlined />}
      //       size="small"
      //       style={{ width: 90, marginRight: 8 }}
      //     >
      //       Search
      //     </Button>
      //     <Button
      //       onClick={() => clearFilters()}
      //       size="small"
      //       style={{ width: 90 }}
      //     >
      //       Reset
      //     </Button>
      //   </div>
      // ),
      // filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
    },

    {
      title: t("formLabels.subscribersInfo.subscriberName"),
      dataIndex: "name",
      key: "name",
      render: (value) => {
        return value !== null ? value : "none";
      },
      // sorter: (a, b) => a.value - b.value,
      // onFilter: (value, record) =>
      //   record.name.toLowerCase().includes(value.toLowerCase()), // Use 'email' here
      // filterDropdown: ({
      //   setSelectedKeys,
      //   selectedKeys,
      //   confirm,
      //   clearFilters,
      // }) => (
      //   <div style={{ padding: 8 }}>
      //     <Input
      //       placeholder={t("formLabels.subscribersInfo.searchSubscriberName")}
      //       value={selectedKeys[0]}
      //       onChange={(e) =>
      //         setSelectedKeys(e.target.value ? [e.target.value] : [])
      //       }
      //       onPressEnter={() => confirm()}
      //       style={{ width: 188, marginBottom: 8, display: "block" }}
      //     />
      //     <Button
      //       type="primary"
      //       onClick={() => confirm()}
      //       icon={<SearchOutlined />}
      //       size="small"
      //       style={{ width: 90, marginRight: 8 }}
      //     >
      //       Search
      //     </Button>
      //     <Button
      //       onClick={() => clearFilters()}
      //       size="small"
      //       style={{ width: 90 }}
      //     >
      //       Reset
      //     </Button>
      //   </div>
      // ),
      // filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
    },
    {
      title: t("formLabels.subscribersInfo.email"),
      dataIndex: "email",
      key: "email",
      render: (value) => {
        return value !== null ? value : "none";
      },
      // sorter: (a, b) => a.value - b.value,
      // onFilter: (value, record) =>
      //   record.email ? record.email.toLowerCase().includes(value.toLowerCase()) : false, // Use 'email' here and check for null
      // filterDropdown: ({
      //   setSelectedKeys,
      //   selectedKeys,
      //   confirm,
      //   clearFilters,
      // }) => (
      //   <div style={{ padding: 8 }}>
      //     <Input
      //       placeholder={t("formLabels.subscribersInfo.searchEmail")}
      //       value={selectedKeys[0]}
      //       onChange={(e) =>
      //         setSelectedKeys(e.target.value ? [e.target.value] : [])
      //       }
      //       onPressEnter={() => confirm()}
      //       style={{ width: 188, marginBottom: 8, display: "block" }}
      //     />
      //     <Button
      //       type="primary"
      //       onClick={() => confirm()}
      //       icon={<SearchOutlined />}
      //       size="small"
      //       style={{ width: 90, marginRight: 8 }}
      //     >
      //       Search
      //     </Button>
      //     <Button
      //       onClick={() => clearFilters()}
      //       size="small"
      //       style={{ width: 90 }}
      //     >
      //       Reset
      //     </Button>
      //   </div>
      // ),
      // filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
    },
    {
      title: t("formLabels.subscribersInfo.code"),
      dataIndex: "code",
      key: "code",
      render: (value) => {
        return value !== null ? value : "none";
      },
      // sorter: (a, b) => a.value - b.value,
      // onFilter: (value, record) =>
      //   record.email ? record.email.toLowerCase().includes(value.toLowerCase()) : false, // Use 'email' here and check for null
      // filterDropdown: ({
      //   setSelectedKeys,
      //   selectedKeys,
      //   confirm,
      //   clearFilters,
      // }) => (
      //   <div style={{ padding: 8 }}>
      //     <Input
      //       placeholder={t("formLabels.subscribersInfo.searchEmail")}
      //       value={selectedKeys[0]}
      //       onChange={(e) =>
      //         setSelectedKeys(e.target.value ? [e.target.value] : [])
      //       }
      //       onPressEnter={() => confirm()}
      //       style={{ width: 188, marginBottom: 8, display: "block" }}
      //     />
      //     <Button
      //       type="primary"
      //       onClick={() => confirm()}
      //       icon={<SearchOutlined />}
      //       size="small"
      //       style={{ width: 90, marginRight: 8 }}
      //     >
      //       Search
      //     </Button>
      //     <Button
      //       onClick={() => clearFilters()}
      //       size="small"
      //       style={{ width: 90 }}
      //     >
      //       Reset
      //     </Button>
      //   </div>
      // ),
      // filterIcon: <SearchOutlined style={{ fontSize: '18px' }} />,
    },
    
  ];
  const customTableHeader = () => (
    <div>
      <span style={{
        background: 'linear-gradient(to right, #7684af, #21daff)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontSize: '28px',
        fontWeight: 'bold',
      }}>
  {t("menu.DrawWinners")}
</span>
      {/* <Button type="primary" onClick={() => setVisible(true)}>
        {t("table.add")}
      </Button> */}
    </div>
  );
  return (
    <Layout dir={isLtr ? "ltr" : "rtl"}>
      <div className={`modern-table-container ${colorTheme==="dark"?"dark-mode":''}`}>
      
        <MyHeader
          // DrawerTitle="This is the drawer title"
          // DrawerFooter="This is the drawer footer"
          HeadercolorTheme={colorTheme}
        />
        
        <Table
          className="custom-table"
          columns={columns}
          dataSource={data}
          rowKey="id"
          pagination={{ defaultPageSize: 10 }}
          onChange={fetchData}
          // expandable={{
          //   expandedRowRender: () => (
          //     <Button onClick={() => setVisible(true)}>Add Record</Button>
          //   ),
          // }}
          title={customTableHeader}
          loading={loading}
          scroll={{ x: '100%' }}
        />
      </div>
    </Layout>
  );
};

export default DrawWinners;
